import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from "vue";
import Webhooks from "@/utils/webhooks";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Webhook',
    props: {
        type: null,
        toolId: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const webhook = ref(null);
        onMounted(() => {
            new Webhooks.WebhookView({
                webhook,
                type: props.type,
                toolId: props.toolId,
            });
        });
        return { __sfc: true, props, webhook };
    }
});
